import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Button, Form, Segment, Message } from "semantic-ui-react";

import { authResetInputChange, authResetRequest } from "../actions";

const ResetPasswordForm = ({
    inputs,
    authResetInputChange,
    authResetRequest,
    resetErrors,
    resetRequesting,
}) => (
    <Form size="large" error={!!resetErrors} onSubmit={() => authResetRequest(inputs)}>
        <Segment stacked>
            <Form.Input
                fluid
                icon="user"
                type="email"
                iconPosition="left"
                value={inputs.email}
                placeholder="E-mail address"
                error={resetErrors && !!resetErrors["email"]}
                onChange={e => authResetInputChange("email", e.target.value)}
            />

            {!!resetErrors && <Message error list={Object.values(resetErrors)} />}

            <Button
                color="teal"
                fluid
                size="large"
                type="submit"
                loading={resetRequesting}
                disabled={resetRequesting}
            >
                Reset Password
            </Button>
        </Segment>

        <Message>
            Got your password? <Link to="/auth/signin">Sign In</Link>
        </Message>
    </Form>
);

const mapStateToProps = ({ auth }) => ({
    inputs: auth.resetInputs,
    isSigningIn: auth.signingIn,
    resetErrors: auth.resetErrors,
    resetRequesting: auth.resetRequesting,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            authResetInputChange,
            authResetRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
